import { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { selectUtmTags } from 'root-redux/selects/common'
import { selectUserGeoState } from 'root-redux/selects/user'

import { isCaliforniaUser } from 'helpers/isCaliforniaUser'
import { isOrganicUser } from 'helpers/isOrganicUser'

export const usePaywallUSConsent = () => {
  const userGeoState = useSelector(selectUserGeoState)
  const utmTags = useSelector(selectUtmTags)

  const [hasUserChangedConsent, setHasUserChangedConsent] = useState(false)

  const shouldCheckConsentByDefault =
    !isCaliforniaUser(userGeoState) && !isOrganicUser(utmTags.utm_source ?? '')

  const [isConsentChecked, setIsConsentChecked] = useState(
    shouldCheckConsentByDefault,
  )
  const [isConsentErrorVisible, setIsConsentErrorVisible] = useState(false)

  useEffect(() => {
    if (hasUserChangedConsent) {
      return
    }

    setIsConsentChecked(shouldCheckConsentByDefault)

    if (shouldCheckConsentByDefault) {
      setIsConsentErrorVisible(false)
    }
  }, [hasUserChangedConsent, shouldCheckConsentByDefault])

  const handleConsentCheckedChange = useCallback((checked: boolean) => {
    setHasUserChangedConsent(true)
    setIsConsentChecked(checked)

    // TODO: Add event to log that users checked the consent checkbox
    if (checked) {
      setIsConsentErrorVisible(false)
    }
  }, [])

  const validateConsent = useCallback((): boolean => {
    if (isConsentChecked) {
      return true
    }

    setIsConsentErrorVisible(true)

    return false
  }, [isConsentChecked])

  return {
    handleConsentCheckedChange,
    isConsentChecked,
    isConsentErrorVisible,
    validateConsent,
  }
}
